import { FunnelHeaderMilestone } from "pax-ui/components";
import { Product } from "src/app/shared/store/shared/product";
import { getPagePath, Page } from "../../shared/shared-route.constant";

// Quote (Pillar 3a)
export const projectionPagePath = getPagePath(
  Product.PILLAR_3A_CONSTANT,
  Page.QUOTE_3A_PROJECTION,
);

// Note: Pay attention to the order of the entries as they are used to display the breadcrumbs for the progress bar
export const quotePillar3aFunnelHeaderMilestones: FunnelHeaderMilestone[] = [
  {
    title: $localize`Antragsdaten erfassen`,
    text: $localize`Prüfen Sie Ihre Eignung für ein Sparanlagenkonto 3a, indem Sie einen Online-Fragebogen zu Ihrer Gesundheit ausfüllen.`,
    steps: [
      {
        title: $localize`Sparplan "Ausgewogen"`,
        path: projectionPagePath,
      },
    ],
  },
];
